// =====================================
//
//   Favorite Address  Controller
//   Author: Gray
//   createtime: 2016 / 09 / 02
//
// =====================================

window.InifECMobileApp.controller("FavoriteAddressController", ['$scope', '$state', '$timeout', '$rootScope', 'UserService', 
	function($scope, $state, $timeout, $rootScope, UserService) {
        
        // --------------------------------
        // [private] 取得會員的常用地址列表
        // --------------------------------
        var qyFavoriteAddress = function() {

            $scope.isLoading = true;

            UserService.qyFavoriteAddress().then(function(result) {

                if(Array.isArray(result) && result.length > 0){
                    $scope.addressList = result;
                } else if($scope.addressList.length == 0) {
                    $scope.isEmpty = true;
                }

                $scope.isLoading = false;

            }, function(error) {

                $scope.isError = true;
                $scope.isLoading = false;
            })
        }

        // -------------------------------
        // 新增常用地址
        // -------------------------------
        var newAddress = function() {

            $rootScope.$broadcast('OPEN_NEW_ADDRESS_MODAL', {
                callback: function(address) {
                    $scope.addressList.push(address);
                    $scope.isEmpty = false;
                }
            });
        }

        // -------------------------------
        // 編輯常用地址
        // -------------------------------
        var editAddress = function(index) {
            
            $rootScope.$broadcast('OPEN_EDIT_ADDRESS_MODAL', {
                index: index,
                address: $scope.addressList[index],
                callback: function(address) {
                    $scope.addressList[index] = address;
                }
            });
        }

        // -------------------------------
        // 刪除常用地址
        // -------------------------------
        var deleteAddress = function(index) {

            $rootScope.$broadcast('OPEN_CONFIRM_MODAL', {
                title: '確定刪除聯絡人',
                description: '',
                callback: function(result) {
                    if(result){
                        UserService.deleteFavoriteAddress(index);
                        $scope.addressList.remove(index);

                        $scope.isEmpty = $scope.addressList.length == 0;
                    }
                }
            });
        }

        // -------------------------------
        // 點擊address 操作按鈕
        // -------------------------------
        var onAddressClick = function(index) {

            $scope.currentIndex = index;
        }

        var init = function() {

            $scope.isLoading = true;
            
            UserService.getUserInfo().then(function(result) {
                qyFavoriteAddress();
            });
        }

        //==========================
        //  Events
        //==========================

        //==========================
        //  Members
        //==========================
        $scope.addressList = [];
        $scope.isError = false;
        $scope.isLoading = false;
        $scope.isEmpty = false;
        $scope.currentIndex;

        //==========================
        //  Methods
        //==========================
        $scope.newAddress = newAddress; // 新增常用地址
        $scope.editAddress = editAddress; // 編輯常用地址
        $scope.deleteAddress = deleteAddress; // 刪除常用地址
        $scope.onAddressClick = onAddressClick; // 點擊address 操作按鈕

        //==========================
        //  Init
        //==========================

        init();
	}
]);